<template>
  <ul class="thread list-group">
    <li
      class="item list-group-item"
      v-for="m in reversedThread"
      v-if="!hasBadWord(m.message)"
      :key="m.key">
      <span class="nickname h4">
        {{ m.nickname }}
      </span>
      :
      <span class="message h4">
        {{ m.message }}
      </span>
    </li>
  </ul>
</template>

<script>
import {
  mapGetters,
  mapState
} from 'vuex'
import l from '@/vendor/logger'

export default {
  name: 'ChatThreadLG',

  created () {
    l.d('ChatThreadLG/created/filteringWords', this.filteringWords)
  },

  computed: {
    ...mapState('chat', [
      'thread'
    ]),
    ...mapGetters('chat', [
      'reversedThread'
    ]),
    ...mapGetters('chatOption', [
      'filteringWords'
    ])
  },

  methods: {
    hasBadWord (msg) {
      if (!msg) return
      return msg.split(' ')
        .filter(m => this.filteringWords.includes(m))
        .reduce((acc, cur) => acc || !!cur, false)
    }
  }
}
</script>

<style scoped>
.thread {
  overflow: scroll;
}
</style>
